import { INTERACTION_CLOSED_STATES } from 'constants-interactions';
import { InvalidInteractionStatusForQRScanError } from 'activate-errors';

export function validateInteractionStatusForScan(interaction: any): void {
  if (INTERACTION_CLOSED_STATES.includes(interaction?.status)) {
    throw new InvalidInteractionStatusForQRScanError();
  }
}
